import { apiClient } from './client';

export interface MandateImage {
  id: string;
  tenant_id: string;
  mandate_id: string;
  filename: string;
  storage_key: string;
  file_size_bytes: number;
  mime_type: string;
  category: string;
  caption: string | null;
  sort_order: number;
  created_at: string;
}

export async function getMandateImages(mandateId: string): Promise<{ data: MandateImage[] }> {
  const { data } = await apiClient.get<{ data: MandateImage[] }>(`/mandate-images/${mandateId}/images`);
  return data;
}

export async function uploadMandateImage(
  mandateId: string,
  file: File,
  category: string = 'sonstiges',
  caption?: string
): Promise<{ data: MandateImage }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);
  if (caption) formData.append('caption', caption);
  const { data } = await apiClient.post<{ data: MandateImage }>(
    `/mandate-images/${mandateId}/images`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function updateMandateImage(
  mandateId: string,
  imageId: string,
  updates: { category?: string; caption?: string; sort_order?: number }
): Promise<{ data: MandateImage }> {
  const { data } = await apiClient.put<{ data: MandateImage }>(
    `/mandate-images/${mandateId}/images/${imageId}`,
    updates
  );
  return data;
}

export async function deleteMandateImage(mandateId: string, imageId: string): Promise<void> {
  await apiClient.delete(`/mandate-images/${mandateId}/images/${imageId}`);
}

export function getMandateImageUrl(imageId: string): string {
  return `/api/v1/mandate-images/file/${imageId}`;
}
